import ApiMServer from 'services/ApiMServer';

const normalizeCertificadoFileList = (data) => {
  if (Array.isArray(data)) {
    return data.filter((item) => typeof item === 'string' && item.trim());
  }
  if (Array.isArray(data?.data)) {
    return data.data.filter((item) => typeof item === 'string' && item.trim());
  }
  if (Array.isArray(data?.files)) {
    return data.files.filter((item) => typeof item === 'string' && item.trim());
  }
  return [];
};

export const getCertificados = async () => {
  const { data } = await ApiMServer.get('/equipment/list/fserver');
  return normalizeCertificadoFileList(data);
};
